import * as React from "react";
import {
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Tooltip,
} from "@mui/material";
import autobind from "autobind-decorator";
import { RouterStore } from "mobx-react-router";
import AccountService from "../../service/AccountService";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import FileService from "../../service/FileService";
import SaveIcon from "@mui/icons-material/Save";
import BackIcon from "@mui/icons-material/ArrowBack";
import hotkeys from "hotkeys-js";
import CloseIcon from "@mui/icons-material/Close";
import { getPlatformType } from "../../Config";
import { styled } from "@mui/material/styles";

const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: "160px",
}));

type SaveButtonProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
  handleSave?: () => void;
  kind: "save" | "back" | "checked-back";
  color?: string;
};

@inject("account")
@inject("routing")
@observer
export default class SaveButton extends React.Component<SaveButtonProps> {
  @observable
  private _loading = false;

  @observable
  private _dialogOpen = false;

  @observable
  private _enteredPassword = "";

  @observable
  private _errorMessage: string = null;

  @autobind
  async handleSave(event: any = null) {
    if (event != null) {
      event.preventDefault();
    }

    var { handleSave, account } = this.props;

    this._loading = true;
    if (handleSave != null) {
      await handleSave();
    }
    this._loading = false;

    if (this.props.kind == "back") {
      account.goBack();
    }

    if (this.props.kind == "checked-back") {
      if (getPlatformType() == "MOBILE") {
        this._enteredPassword = "";
        this._errorMessage = null;
        this._dialogOpen = true;
      } else {
        account.goBack();
      }
    }
  }

  componentDidMount() {
    if (this.props.kind == "save") {
      hotkeys("ctrl+s,command+s", this.handleSave);
    }
  }

  componentWillUnmount() {
    if (this.props.kind == "save") {
      hotkeys.unbind("ctrl+s, command+s");
    }
  }

  @autobind
  handleClose() {
    this._enteredPassword = "";
    this._errorMessage = null;
    this._dialogOpen = false;
  }

  @autobind
  handlePasswordChange(event) {
    this._enteredPassword = event.target.value;
  }

  @autobind
  handleSubmit() {
    if (this._enteredPassword != this.props.account.userData.password) {
      this._errorMessage = "Entered password is incorrect.";
    } else {
      this._errorMessage = null;
      if (this.props.kind == "checked-back") {
        localStorage.removeItem("Qid");
        this.props.account.goBack();
      }
    }
  }

  renderDialog() {
    return (
      <Dialog
        open={this._dialogOpen}
        onClose={this.handleClose}
        maxWidth="xs"
        fullWidth
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography style={{ flexGrow: 1 }}>
            Enter your password to go back.
          </Typography>
          <IconButton aria-label="close" onClick={this.handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Enter Password"
            autoFocus
            type="password"
            autoComplete="current-password"
            value={this._enteredPassword}
            onChange={this.handlePasswordChange}
            error={this._errorMessage != null}
            helperText={this._errorMessage}
          />
        </DialogContent>
        <DialogActions>
          <SubmitButton
            variant="contained"
            onClick={this.handleSubmit}
            color="primary"
            style={{ marginRight: 24 }}
          >
            {" "}
            GO BACK
          </SubmitButton>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const Icon = this.props.kind == "save" ? SaveIcon : BackIcon;
    const tooltipText =
      this.props.kind == "save" ? "Save changes" : "Go to workflow listings";
    return (
      <React.Fragment>
        <Tooltip title={tooltipText} placement="bottom">
          {this.props.kind == "save" ? (
            <Button
              onClick={this.handleSave}
              disabled={this._loading}
              style={{
                color: "inherit",
                minWidth: "100px",
                justifyContent: "flex-start",
              }}
            >
              {this._loading ? (
                <CircularProgress
                  size={18}
                  style={{
                    color: `${this.props.color ? this.props.color : "white"}`,
                    marginRight: "10px",
                  }}
                />
              ) : (
                <Icon style={{ marginRight: "10px" }} />
              )}
              <span>SAVE</span>
            </Button>
          ) : (
            <IconButton
              onClick={this.handleSave}
              disabled={this._loading}
              style={{ color: "white" }}
            >
              {this._loading ? (
                <CircularProgress size={18} style={{ color: "white" }} />
              ) : (
                <Icon />
              )}
            </IconButton>
          )}
        </Tooltip>
        {this.renderDialog()}
      </React.Fragment>
    );
  }
}
